import React from "react";
import EmptyIcon from "./EmptyIcon.js";

const EmptyState = ({
  icon = <EmptyIcon />,
  title = "No data found",
  description = "There's nothing to display at the moment.",
  actionButton,
  className = "",
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-state__content">
        <div className="empty-state__icon-wrapper">{icon}</div>
        <h3 className="empty-state__title">{title}</h3>
        <p className="empty-state__description">{description}</p>
        {actionButton && (
          <div className="empty-state__action">{actionButton}</div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
